import React from 'react';

import AccountLink from './AccountLink/AccountLink';

const LoggedOutNav = () => <AccountLink href="/login">Sign in</AccountLink>;

export default LoggedOutNav;
